import {Button, Card, Spinner, Typography} from "@material-tailwind/react";
import React, {useEffect, useMemo, useState} from "react";
import useInputValue from "../../hooks/useInputValue";
import getConstrains from "../../utils/validationConstraints";
import useValidation from "../../hooks/useValidation";
import Logo from "../../components/general/Logo";
import CustomInputPassword from "../../components/general/CustomInputPassword";
import CustomInput from "../../components/general/CustomInput";
import {showToast} from "../../components/general/CustomToast";
import {useTranslation} from "react-i18next";
import {useCredentials} from "../../services/session/apiSession";
import {useSessionStore} from "../../services/storage/session/SessionStorage";
import {useNavigate} from "react-router";

interface ErrorProps {
    username?: string;
    password?: string;
}

export function Login() {
    const history = useNavigate();
    const {t} = useTranslation("global") as { t: (key: string) => string }
    const {mutate, isPending, data: successLogin} = useCredentials()
    const setData = useSessionStore(state => state.setData)

    const username = useInputValue('')
    const password = useInputValue('')

    const [errors, setErrors] = useState<ErrorProps | null>();
    const validationSchema = useMemo(() => getConstrains(['username', 'password']), []);
    const validation = useValidation(validationSchema);

    const login = () => {
        const data = {
            username: username.value,
            password: password.value
        }
        const errorsValidation = validation(data);
        if (errorsValidation) {
            setErrors(errorsValidation);
            showToast(t('field-validation'), 'error');
        } else {
            setErrors(null)
            mutate(data)
        }
    }

    useEffect(() => {
        if (successLogin) {
            setData(successLogin)
            history('/')
        }
    }, [successLogin]);

    return (
        <div className={"relative grid justify-center items-center"}>
            <Card placeholder={'card-login'} className={"p-4 sm:w-[415px]"} shadow={false}>
                <div className={"grid justify-end"}>
                    <Logo width={200}/>
                </div>
                <Typography placeholder={'login-title'} variant="h4" color="blue-gray">
                    {t('welcome')}
                </Typography>
                <Typography placeholder={'alet-title'} color="gray" className="mt-1 font-normal">
                    {t('login')}
                </Typography>
                <div className="mb-4 mt-4 flex flex-col gap-6">
                    <CustomInput labelFixel={true} label={'Username'} error={errors?.username} {...username} />
                    <CustomInputPassword error={errors?.password} eventSistem={() => {
                        login()
                    }} {...password}/>
                </div>
                <Button
                    placeholder={'button-login'}
                    variant="gradient"
                    color="green" className="mt-1 " fullWidth
                    disabled={isPending}
                    onClick={login}
                >
                    <div className="flex justify-center items-center">
                        <span>{t('loginText')}</span>
                        {isPending &&
                            <Spinner className="h-4 w-4 ml-2" color="blue"/>
                        }
                    </div>
                </Button>
            </Card>
        </div>
    )
}
